<template>
 <section class="bg-white text-gray-600 xl:px-20 lg:px-8 md:px-10 px-6 overflow-hidden relative font-poppins z-0"> 
  <!-- Background Decoration -->
  <img src="@/assets/bg2.svg" alt="Background Decoration" 
       class="absolute top-0 right-0 w-full xl:w-1/3 z-0">

  <div class="flex flex-col lg:flex-row md:flex-col xl:flex-row w-full xl:items-start gap-16 relative z-10 xl:py-0 lg:py-10 md:py-20 py-8">
    
    <!-- Image with No Width Restriction on XL -->
    <div class="relative flex-1 xl:flex-[1] ">
      <img src="@/assets/step.svg" alt="Step Image" 
           class="w-full h-auto max-w-none object-contain transform hover:scale-105 transition-transform duration-500">
    </div>

    <!-- Text Content -->
    <div class="text-start flex-1 max-w-full mx-auto z-0 ">
      <div class="flex items-center justify-start mb-3">
        <div class="h-7 rounded-lg w-1 bg-[#186a85]"></div>
        <span class="px-2 py-2 bg-opacity-20 text-[#186a85] font-sm text-lg tracking-wider z-40">How We Start</span>
      </div>
      <h2 class="text-gray-700 xl:text-4xl lg:text-xl md:text-lg text-md font-semibold mb-8 text-start z-40">
        Our First Step
      </h2>
      <p class="text-gray-600 text-base md:text-md lg:text-lg xl:text-lg text-justify tracking-wide leading-relaxed antialiased z-40">
        We start our business from a small team in 2008. Established as PT Pasifik Hoki Indonesia (PHISOFT) on 27th May 2015. PHISOFT is a tech company, not only a software house. We focus on manufacturing and development of the technology and provide technology as a service. Our team consists of System Analyst, Certified IT Consultant/ Advisor/ Coach, HRIS/ HCMS Consultant, ERP Functional Consultant, Project Manager, Desktop Platform Engineer, Web Platform Engineer, Mobile App Engineer (Android & iOS), Web Designer, Graphic & Multimedia Designer, IT Support, Helpdesk & Customer Service, Business Development Team, Marketing & Public Relation Team to serve our valued customers.
      </p>
    </div>

  </div>
</section>
 </template>
 
 <script>

 export default {
   name: 'AboutSection',
   data() {
     return {
       visible: false
     };
   },
   mounted() {
     // Simple entrance animation
     setTimeout(() => {
       this.visible = true;
     }, 100);
     
   },
 };
 </script>
 <style>
 
 </style>